'use strict';

var GridCustomizeSortButtonDirective = function GridCustomizeSortButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-customize-sort-button.html')
  };
};
GridCustomizeSortButtonDirective.$inject = [];
module.exports = GridCustomizeSortButtonDirective;